// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const NYCKEL = 'sm-tema-forhandsvisning';
  const TEMA = 'bld';
  const html = document.documentElement;

  const bakgrund = () => {
    const meta = document.querySelector('meta[name="theme-color"]');
    return meta?.dataset.bakgrund || '#ffffff';
  };

  const synkaFarg = () => {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    meta.content = html.dataset.tema === TEMA ? '#0a0a0a' : bakgrund();
  };

  const synkaKnapp = () => {
    const knapp = document.querySelector('[data-action~="tema/bld"]');
    if (!knapp) return;
    const pa = html.dataset.tema === TEMA;
    knapp.dataset.state = pa ? 'pa' : 'av';
    knapp.setAttribute('aria-pressed', pa ? 'true' : 'false');
  };

  const satt = (pa) => {
    if (pa) html.dataset.tema = TEMA;
    else html.removeAttribute('data-tema');
    synkaFarg();
    synkaKnapp();
  };

  synkaKnapp();

  document.addEventListener('click', (e) => {
    const knapp = e.target.closest('[data-action~="tema/bld"]');
    if (!knapp) return;
    const pa = html.dataset.tema !== TEMA;
    satt(pa);
    try {
      sessionStorage.setItem(NYCKEL, pa ? TEMA : 'av');
    } catch (err) {}
  });
})();
